import { Box, Button, Stack, TextField, Typography } from "@mui/material";

import { stringConstant } from "../utils/string-utils";
// import '../app/css/additional-styles/login.css'
// import '../app/css/additional-styles/page-content.css'
// import '../app/css/global.css'
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { appApi } from "../apiUtils/apiMethod";
import { Url } from "../apiUtils/apiPath";
import Logger from "../utils/logger";
import { notifyError, notifySuccess } from "../utils/common-utils";
import { MobileNumberInput } from "./customComponents/mobileNumberInput";
export default function Login() {

    const navigate = useNavigate()
    const [clinicData, setClinicData] = useState({
        authentication_type: "mpin",
        kiosk_id: null,
        authentication_value: null
    });

    const handleClinicData = (fieldName) => (event) => {
        setClinicData({
            ...clinicData,
            [fieldName]: event.target.value,
        });
    };
    useEffect(() => {

    }, [clinicData])
    const handleSignIn = async () => {
        console.log("Login------->", clinicData);
        const hasNullOrEmptyValues = Object.entries(clinicData).some(([key, value]) => {
            if (value === null || value === '') {
                notifyError(`Enter ${key == 'kiosk_id' ? 'Clinic Id' : 'Password'}`)
                return true;
            }
            return false;
        });
        if (!hasNullOrEmptyValues) {
            const data = {
                authentication_type: "mpin",
                kiosk_id: clinicData?.kiosk_id,
                authentication_value: clinicData?.authentication_value
            };
            await appApi(Url.LOGIN_KIOSK, "POST", { "Content-Type": "application/json" }, JSON.stringify(data))
                .then((result) => {
                    if (result.found === true) {
                        console.log("result--------->", result);
                        localStorage.setItem('clinic', result?.data?.id)
                        notifySuccess("Login Successful")
                        navigate('/home');
                    } else if (result.found == false) {
                        notifyError(result.data.message);
                    } else {
                        notifyError(result.message)
                    }
                });
        }
        // else {
        //     notifyError(`Enter ${clinicData.kiosk_id == null || clinicData.kiosk_id == '' ? 'clinic ID' : ''} ${clinicData.authentication_value == null || clinicData.authentication_value == '' ? 'password' : ''}`);
        // }
    };



    return (
        <main className="grow">

            <div className="max-w-6xl mx-auto px-4 sm:px-6">
                <div className="pt-32 pb-12 md:pt-40 md:pb-20">
                    <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
                        <h1 className="h1">Empowering Society for a Healthier Tomorrow</h1>
                        <p className="text-md text-gray-300 mb-8" data-aos="fade-up" data-aos-delay="200">Making preventive healthcare more Affordable,Advanced and Accessible</p>
                    </div>
                    <div className="max-w-sm mx-auto">
                        <form>
                            <div className="flex flex-wrap -mx-3 mb-4">
                                <div className="w-full px-3">
                                    <label className="block text-gray-300 text-sm font-medium mb-1" htmlFor="number">Clinic ID</label>
                                    <input id="number" type="text" className="form-input w-full text-gray-300 bg-transparent" placeholder="Clinic ID" required onChange={handleClinicData("kiosk_id")} />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mb-4">
                                <div className="w-full px-3">
                                    <label className="block text-gray-300 text-sm font-medium mb-1" htmlFor="password">M-pin</label>
                                    <input id="number" type="text" value={clinicData.authentication_value} className="form-input w-full text-gray-300 bg-transparent" placeholder="Password (at least 6 characters)" required onChange={(event) => {
                                        if (event.target.value.length <= 6) {
                                            setClinicData({
                                                ...clinicData,
                                                authentication_value: event.target.value,
                                            });
                                        }
                                    }} />
                                </div>
                            </div>
                            <div className="flex flex-wrap -mx-3 mt-6">
                                <div className="w-full px-3">
                                    {/* Add onClick event handler to the Sign in button */}
                                    <a className="btn text-white bg-purple-600 hover:bg-purple-700 w-full" onClick={() => { handleSignIn() }}>Sign in</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </main>
        // <Stack
        //     className="landing-theme"
        //     spacing={2}
        // >
        //     <Stack width={'100%'} alignItems={'center'} spacing={1}>
        //         <Typography className="landing-title" fontSize={{ xl: '4rem', lg: '3rem', md: '3rem', sm: '2rem' }} width={{ xl: '50%', lg: '55%', md: '60%', sm: '80%' }}>{stringConstant.LOGIN_TITLE}</Typography>
        //         <Typography className="landing-body" fontSize={{ xl: '2.5rem', lg: '2rem', md: '2rem', sm: '2rem' }} width={{ xl: '50%', lg: '60%', md: '70%', sm: '80%' }}>{stringConstant.LOGIN_BODY}</Typography>
        //     </Stack>
        //     <Stack width={'35%'} spacing={4} >
        //         <Stack spacing={1} height={{ xl: '10vh', lg: '12vh', md: '12vh' }} color={'#ffffff'} width={'100%'}>
        //             <Typography fontSize={{ sm: '1rem', lg: '1.2rem', md: '1.2rem' }}>
        //                 {stringConstant.CLINIC_ID}
        //             </Typography>
        //             <MobileNumberInput color={"#ffffff"} value={clinicData?.kiosk_id} onChange={handleClinicData("kiosk_id")} placeholder='Enter ClinicId' />
        //         </Stack>
        //         <Stack spacing={1} height={{ xl: '10vh', lg: '12vh', md: '12vh' }} color={'#ffffff'}>
        //             <Typography fontSize={{ sm: '1rem', lg: '1.2rem', md: '1.2rem' }}>
        //                 {stringConstant.PASSWORD}
        //             </Typography>
        //             <MobileNumberInput color={"#ffffff"} value={clinicData?.authentication_value} onChange={(event) => {
        //                 if (event.target.value.length <= 6) {
        //                     setClinicData({
        //                         ...clinicData,
        //                         authentication_value: event.target.value,
        //                     });
        //                 }
        //             }} placeholder='Enter Password' />
        //         </Stack>
        //         <Stack>
        //             <Button className="button-primary" sx={{
        //                 width: '100% !important',
        //                 alignSelf: 'start !important'
        //             }} onClick={() => {
        //                 loginApi()
        //             }}>
        //                 {stringConstant.SIGNIN}
        //             </Button>
        //         </Stack>
        //     </Stack>
        // </Stack >
    )
}
